import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api';
import Layout from '../components/Layout';
import HotspotEditor from '../components/HotspotEditor';

const UPLOADS_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:3301/api').replace('/api', '');

const MOTOR_TYPES = {
  adventure: `${UPLOADS_BASE}/uploads/adventure.png`,
  matic: `${UPLOADS_BASE}/uploads/matic.png`,
  bebek: `${UPLOADS_BASE}/uploads/bebek.png`,
  'big-scooter': `${UPLOADS_BASE}/uploads/big-scooter.png`,
  kopling: `${UPLOADS_BASE}/uploads/kopling.png`,
};

const GEAR_PLACEHOLDER = "data:image/svg+xml;utf8," + encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 400">
    <circle cx="100" cy="50" r="35" fill="#262b33"/>
    <rect x="70" y="90" width="60" height="120" rx="16" fill="#262b33"/>
    <rect x="55" y="100" width="20" height="90" rx="10" fill="#262b33"/>
    <rect x="125" y="100" width="20" height="90" rx="10" fill="#262b33"/>
    <rect x="75" y="210" width="22" height="150" rx="10" fill="#262b33"/>
    <rect x="103" y="210" width="22" height="150" rx="10" fill="#262b33"/>
  </svg>
`);

const MOTOR_SUGGESTED_LABELS = ['Ban', 'Lampu', 'Shock Breaker', 'Knalpot', 'Jok', 'Mesin'];
const GEAR_SUGGESTED_LABELS = ['Helm', 'Intercom', 'Jaket', 'Sarung Tangan', 'Sepatu', 'Tas'];

export default function MemberHotspot() {
  const { id } = useParams();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/member-auth/admin/${id}/full`)
      .then((res) => setMember(res.data))
      .catch((err) => {
        console.error(err);
        alert('Gagal ambil detail member');
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <Layout><p style={{ color: '#8B92A0' }}>Memuat...</p></Layout>;
  if (!member) return <Layout><p style={{ color: '#D02127' }}>Member tidak ditemukan.</p></Layout>;

  const motorSilhouette = MOTOR_TYPES[member.motor_type] || null;
  const motorSpecs = Array.isArray(member.motor_specs) ? member.motor_specs : [];
  const gearSpecs = Array.isArray(member.gear_specs) ? member.gear_specs : [];

  return (
    <Layout>
      <Link to="/members" style={{ color: '#2B6996', fontSize: 13, textDecoration: 'none' }}>← Kembali ke Kelola Member</Link>
      <h1 style={{ fontSize: 26, fontWeight: 900, fontStyle: 'italic', margin: '12px 0 24px' }}>
        Atur Hotspot — {member.name}
      </h1>

      <div style={{ marginBottom: 40 }}>
        <h2 style={{ fontSize: 16, color: '#8B92A0', marginBottom: 12 }}>
          Tipe Motor: <span style={{ color: '#F0EDE4', fontWeight: 700 }}>{member.motor_type || 'Belum diisi'}</span>
        </h2>
        {motorSilhouette ? (
          <HotspotEditor
            title="Hotspot Motor"
            silhouetteUrl={motorSilhouette}
            initialSpecs={motorSpecs}
            saveEndpoint={`/member-auth/admin/${id}/motor-specs`}
            bodyKey="motor_specs"
            suggestedLabels={MOTOR_SUGGESTED_LABELS}
          />
        ) : (
          <p style={{ color: '#5a616e', fontSize: 13 }}>Member belum pilih tipe motor, belum bisa atur hotspot motor.</p>
        )}
      </div>

      <div>
        <h2 style={{ fontSize: 16, color: '#8B92A0', marginBottom: 12 }}>Gear</h2>
        <HotspotEditor
          title="Hotspot Gear"
          silhouetteUrl={GEAR_PLACEHOLDER}
          initialSpecs={gearSpecs}
          saveEndpoint={`/member-auth/admin/${id}/gear-specs`}
          bodyKey="gear_specs"
          suggestedLabels={GEAR_SUGGESTED_LABELS}
        />
      </div>
    </Layout>
  );
}
